import React from 'react';
import { compose } from 'redux';
import DashboardTemplate from 'components/templates/Dashboard';
import HeaderContainer from 'containers/HeaderContainer';
import PageQuery from 'hoc/PageQuery';
import PageView from 'hoc/PageView';
import PageTitle from 'hoc/PageTitle';
import ProtectedRoute from 'hoc/ProtectedRoute';
import PageTheme from 'hoc/PageTheme';

import DetermineLayerContainer from 'containers/dashboards/DetermineLayerContainer';
import LayerThreeSiteDirectContainer from 'containers/dashboards/LayerThreeSiteDirectContainer';

import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { SideBarObjects } from 'components/pages/config/DashboardSideBarObjects';
import showGGBrandingTheme from 'helpers/showGGBrandingTheme';
import { getQueryParamDefForObjectiveSwitcher } from 'helpers/objectiveSettings';
import { getQueryParamDefForRange } from 'helpers/range';

const SiteDirectDashboard = props => (
    <DashboardTemplate
        header={<HeaderContainer />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer entityId={parseInt(props.match.params.entityId, 10)}/>}>

        <DetermineLayerContainer
            layerTwo={LayerThreeSiteDirectContainer}
            layerThree={LayerThreeSiteDirectContainer}
            {...props} />
    </DashboardTemplate>
);

export default compose(
    ProtectedRoute(),
    PageTitle({ pageTitle: 'Site Direct' }),
    PageView({ page: 'Viewed Entity Site Direct', trackEntity: true }),
    PageTheme({ themeDefaults: { 'whitelabel.showGGBranding': showGGBrandingTheme } }),
    PageQuery({
        params: {
            ...getQueryParamDefForRange(),
            ...getQueryParamDefForObjectiveSwitcher()
        },
        initialTruth: 'location',
    }),
)(SiteDirectDashboard);



// WEBPACK FOOTER //
// ./src/components/pages/dashboards/SiteDirect.js